import { Form } from "containers/Form/newForm";
import { useState } from "react";
import { Row } from "reactstrap";
import { Container, Logo, MainContainer } from "./styled";
import lockImage from 'template/images/Lock.png'
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SuccessfullMessage from "containers/Form/SuccessfullMessage";

const brandLogoSrc =
  (process.env.REACT_APP_BRAND_LOGO_URL || "").trim() || "/tradepro_logo.png";
const brandPartnerLine =
  (process.env.REACT_APP_BRAND_PARTNER_TAGLINE || "").trim() ||
  "Enter your details to create your Partner Account.";

function App() {
  const [popUp, setPopUp] = useState(false);

  return (
    <MainContainer>
      <Row className="header partner-brand-bar">
        <div className="partner-brand-bar-inner">
          <Logo src={brandLogoSrc} alt="I Trade Pro" className="mt-2 partner-brand-bar-logo" />
          <p style={{ marginBottom: '0px', fontSize: '16px' }} className="top_sec_p partner-brand-bar-message">
            <img
              src={lockImage}
              style={{ marginTop: '-3px', width: '20px', marginRight: '15px' }}
              alt="Lock Icon"
            />
            {brandPartnerLine}
          </p>
        </div>
      </Row>
      {/*<Row className="text-center mt_50">
        <h1 className="secondary">Application Form</h1>
        <p className="primary">Create your live trading account in less than 59 seconds.</p>
  </Row>*/}
      <Container>
        <Form setPopUp={setPopUp} />
      </Container>
      <SuccessfullMessage popUp={popUp} setPopUp={setPopUp} />
      <div className="footer">
        <div className="footer-content">
          <div className="footer-heading-row">
            <p className="footer-title">ITradePro Markets</p>
            <p className="footer-subtitle">Brokered by GODO LTD</p>
          </div>
          <p className="footer-support-line">For assistance, please contact our Client Service Team, at: support@itradepromarkets.com</p>
          <div className="footer-license-row">
            <p className="footer-section-title">Licensed by,</p>
            <p>FSC Mauritius - License No. GB20025812</p>
            <p>SCA UAE - License No. 20200000168</p>
          </div>
          <p className="footer-authorized-line">Authorized to provide services and accept clients from residents and citizens of the UAE and the region</p>
          <p>
            Risk Warning: Trading in Forex/CFDs and Other Derivatives is highly speculative and carries a high level of risk.
            It is possible to lose all your capital. These products may not be suitable for everyone and you should ensure
            that you understand the risks involved. Seek independent advice if necessary. Speculate only with funds that you
            can afford to lose.
          </p>
          <p>
            The information on this site is not directed at residents of the United States and is not intended for distribution
            to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local
            law or regulation.
          </p>
          <p>
            The domain www.itradepromarkets.com is operated by iTradePro Markets (brokered by GODO LTD). GODO LTD is authorized
            and regulated by the Financial Service Commission (FSC) in Mauritius (License No. GB20025812) and the Securities and
            Commodities Authority (SCA) in UAE (License No. 20200000168).
          </p>
        </div>
      </div>

      <ToastContainer />
    </MainContainer>
  );
}

export default App;